module.exports = __webpack_public_path__ + "img/dcd.82e807d1.png";